<h2 mat-dialog-title>Send Historical Reservation Data</h2>
<div mat-dialog-content>
  <p>Are you sure you want to send all historical reservation data for the webhook?</p>
  <p>
    This action will resend all past reservation webhook events, which may result in duplicate data being sent to the
    webhook endpoint.
  </p>
</div>
<div mat-dialog-actions align="end" class="flex gap-3">
  <sbnb-button type="secondary" (click)="onCancel()">Cancel</sbnb-button>
  <sbnb-button type="primary" (click)="onConfirm()">Send Historical Data</sbnb-button>
</div>
